import React, { useEffect, useState } from 'react';
interface CountdownProps {
  initialHours?: number;
  initialMinutes?: number;
  initialSeconds?: number;
}
export function Countdown({
  initialHours = 23,
  initialMinutes = 57,
  initialSeconds = 40
}: CountdownProps) {
  const [timeLeft, setTimeLeft] = useState({
    hours: initialHours,
    minutes: initialMinutes,
    seconds: initialSeconds
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.hours === 0 && prev.minutes === 0 && prev.seconds === 0) {
          clearInterval(timer);
          return prev;
        }
        let newSeconds = prev.seconds - 1;
        let newMinutes = prev.minutes;
        let newHours = prev.hours;
        if (newSeconds < 0) {
          newSeconds = 59;
          newMinutes -= 1;
        }
        if (newMinutes < 0) {
          newMinutes = 59;
          newHours -= 1;
        }
        return {
          hours: newHours,
          minutes: newMinutes,
          seconds: newSeconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const format = (num: number) => num.toString().padStart(2, '0');
  return <div className="flex items-center justify-center space-x-2 text-3xl md:text-4xl font-bold font-sans text-primary" data-id="element-37">
      <div className="flex flex-col items-center" data-id="element-38">
        <div className="bg-white px-3 py-2 rounded-lg shadow-sm border border-gray-100 min-w-[60px] text-center" data-id="element-39">
          {format(timeLeft.hours)}
        </div>
        <span className="text-xs text-gray-500 mt-1 uppercase tracking-wider font-normal" data-id="element-40">
          hs
        </span>
      </div>
      <span className="text-gray-400 pb-5" data-id="element-41">:</span>
      <div className="flex flex-col items-center" data-id="element-42">
        <div className="bg-white px-3 py-2 rounded-lg shadow-sm border border-gray-100 min-w-[60px] text-center" data-id="element-43">
          {format(timeLeft.minutes)}
        </div>
        <span className="text-xs text-gray-500 mt-1 uppercase tracking-wider font-normal" data-id="element-44">
          min
        </span>
      </div>
      <span className="text-gray-400 pb-5" data-id="element-45">:</span>
      <div className="flex flex-col items-center" data-id="element-46">
        <div className="bg-white px-3 py-2 rounded-lg shadow-sm border border-gray-100 min-w-[60px] text-center" data-id="element-47">
          {format(timeLeft.seconds)}
        </div>
        <span className="text-xs text-gray-500 mt-1 uppercase tracking-wider font-normal" data-id="element-48">
          seg
        </span>
      </div>
    </div>;
}